<div class="ui stackable grid">
  <div [ngClass]="[columnsCount, 'columns row']" #columns>
    <ng-container *ngFor="let option of options">
      <div class="column" #column>
        <button
          class="ui button"
          [attr.data-option]="option.id"
          [class.active]="isActiveOptionValue(option.id)"
          (click)="onOptionValueSelect(option.id)"
        >
          <div class="content">
            <div class="checkbox" *ngIf="multiple">
              <ui-checkbox
                [checked]="isActiveOptionValue(option.id)"
                (checkedChange)="onOptionValueSelect(option.id)"
              ></ui-checkbox>
            </div>
            <img *ngIf="option.image" [src]="option.image | assetsPath | async" alt="" width="48" height="48" />
            <div class="text">
              <div>{{ option.name | translate }}</div>
              <div *ngIf="option.subtitle" class="subtitle">{{ option.subtitle | translate }}</div>
            </div>
          </div>
        </button>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="collapse" class="collapse-btn">
  <button class="ui button" (click)="viewToggle()">
    {{ collapseBtnTranslationKey | translate }}
    <i class="angle icon" [ngClass]="{ down: !isViewMoreOpen, up: isViewMoreOpen }"></i>
  </button>
</div>
